<mat-card [class.configured]="configureSelected">
    <mat-card-header class="widget-header">
        <mat-card-title>
            <span>{{ type() | titlecase }} Outages</span>
        </mat-card-title>

        <!--        <button-->
        <!--            class="hide-on-export"-->
        <!--            matTooltip="Export as PNG"-->
        <!--            matTooltipPosition="above"-->
        <!--            matTooltipShowDelay="250 "-->
        <!--            mat-icon-button-->
        <!--            (click)="exportComponent()">-->
        <!--            <vulcan-icon icon="download-simple" weight="bold"></vulcan-icon>-->
        <!--        </button>-->
    </mat-card-header>

    <mat-card-content>
        <div class="table-container">
            <table
                mat-table
                [dataSource]="dataSource"
                #tableSort="matSort"
                matSort
                matSortDisableClear
                matSortActive="currentOutages"
                matSortDirection="desc">
                <ng-container matColumnDef="county">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="small-col">
                        County
                        <eaglei-table-sort-header [columnName]="'county'" [sort]="tableSort"></eaglei-table-sort-header>
                    </th>
                    <td mat-cell *matCellDef="let info" class="small-col">
                        <span> {{ info.countyName }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="icon-col">
                        State/Territory
                        <eaglei-table-sort-header [columnName]="'state'" [sort]="tableSort"></eaglei-table-sort-header>
                    </th>
                    <td mat-cell *matCellDef="let info">{{ info.stateName | stateName }}</td>
                </ng-container>

                <ng-container matColumnDef="currentOutages">
                    <th class="right-cell" mat-header-cell mat-sort-header *matHeaderCellDef>
                        <div class="sort-header">
                            <span>Current Outages</span>
                            <eaglei-table-sort-header [columnName]="'currentOutages'" [sort]="tableSort"></eaglei-table-sort-header>
                        </div>
                    </th>
                    <td class="right-cell small-col" mat-cell *matCellDef="let info">
                        <div>
                            {{ info.currentOutages | eagleiNumber }}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="percentOut">
                    <th class="right-cell small-col" mat-header-cell mat-sort-header *matHeaderCellDef>
                        <div class="sort-header">
                            <span>Percent Out</span>
                            <eaglei-table-sort-header [columnName]="'percentOut'" [sort]="tableSort"></eaglei-table-sort-header>
                        </div>
                    </th>
                    <td class="right-cell small-col" mat-cell *matCellDef="let info">
                        <div>
                            <span>
                                {{ info.percentOutages | percent : '1.1-2' }}
                            </span>
                            <ng-template #unavailable>
                                <span>Not Available</span>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="peak">
                    <th class="right-cell" mat-header-cell mat-sort-header *matHeaderCellDef>
                        <div class="sort-header">
                            <span>Peak Outages</span>
                            <eaglei-table-sort-header [columnName]="'peak'" [sort]="tableSort"></eaglei-table-sort-header>
                        </div>
                    </th>
                    <td class="right-cell" mat-cell *matCellDef="let info">
                        <div>
                            <span *ngIf="info.peakOutages; else noCustomers">
                                {{ info.peakOutages | eagleiNumber }}
                            </span>
                            <ng-template #noCustomers> Not Available</ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="peakTime">
                    <th class="right-cell med-col" mat-header-cell mat-sort-header *matHeaderCellDef>
                        <div class="sort-header">
                            <span>Peak Time</span>
                            <eaglei-table-sort-header [columnName]="'peakTime'" [sort]="tableSort"></eaglei-table-sort-header>
                        </div>
                    </th>
                    <td class="right-cell med-col" mat-cell *matCellDef="let info">
                        <div>
                            <span *ngIf="info.peakTime; else noCustomers">
                                {{ info.peakTime | momentDate : 'MM/DD/YYYY hh:mm A' }}
                            </span>
                            <ng-template #noCustomers> Not Available</ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="percentRestored">
                    <th class="right-cell small-col" mat-header-cell mat-sort-header *matHeaderCellDef>
                        <div class="sort-header">
                            <span>Percent Restored</span>
                            <eaglei-table-sort-header [columnName]="'percentRestored'" [sort]="tableSort"></eaglei-table-sort-header>
                        </div>
                    </th>
                    <td class="right-cell small-col" mat-cell *matCellDef="let info">
                        <div>
                            <span>
                                {{ info.percentRestored | percent : '1.2-2' }}
                            </span>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns()"></tr>
                <tr mat-row *matRowDef="let row; columns: columns(); let odd = odd"></tr>
            </table>
            <mat-paginator class="hide-on-export" [pageSizeOptions]="[5, 10, 15, 25]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
